export default __webpack_public_path__ + "static/media/HT-2.22fe5076.png";